export default "__VITE_ASSET__C0ZeNl8h__"